// @flow

import i18n from "i18next";
import k from "src/i18n/keys";
import { useSelector, useDispatch } from "react-redux";
import React, { useCallback } from "react";

import { disableUser, hideDisableUserModal } from "src/actions/user";
import { makeAdmin, makeMember } from "src/actions/user";
import { getDisableUserModalData } from "src/reducers";
import Header from "./Header";
import BodyContent from "./BodyContent";
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
  ModalActionButton,
} from "@unifize/sarah";

const Disable = () => {
  const dispatch = useDispatch();
  const { uid, adminModal, memberModal } = useSelector(({ app }) =>
    getDisableUserModalData(app),
  );

  const hideModal = useCallback(() => {
    dispatch(
      hideDisableUserModal({
        uid: null,
        adminModal: false,
        memberModal: false,
      }),
    );
  }, [hideDisableUserModal]);

  const handleDisable = useCallback(() => {
    dispatch(disableUser(uid));
    hideModal();
  }, [disableUser, hideModal, uid]);

  const handleMakeAdmin = useCallback(() => {
    dispatch(makeAdmin(uid));
    hideModal();
  }, [uid, makeAdmin, hideModal]);

  const handleMakeMember = useCallback(() => {
    dispatch(makeMember(uid));
    hideModal();
  }, [uid, makeMember, hideModal]);

  const showDisable = !adminModal && !memberModal;

  const handleClick = useCallback(() => {
    if (memberModal) {
      handleMakeAdmin();
    } else if (adminModal) {
      handleMakeMember();
    } else if (showDisable) {
      handleDisable();
    }
  }, [
    showDisable,
    memberModal,
    handleMakeAdmin,
    adminModal,
    handleMakeMember,
    handleDisable,
  ]);

  if (uid) {
    return (
      <Modal
        height="auto"
        isOpen={showDisable || adminModal || memberModal}
        onClose={() =>
          dispatch(
            hideDisableUserModal({
              uid: null,
              adminModal: false,
              memberModal: false,
            }),
          )
        }
      >
        <ModalHeader>
          <Header uid={uid} />
        </ModalHeader>

        <ModalContent>
          <BodyContent uid={uid} />
        </ModalContent>

        <ModalFooter>
          <ModalActionButton variant="destructive" onClick={handleClick}>
            {memberModal
              ? i18n.t(k.MAKE_ADMIN)
              : adminModal
                ? i18n.t(k.MAKE_MEMBER)
                : showDisable
                  ? i18n.t(k.DISABLE_AND_CLEAR_ALL_DATA)
                  : null}
          </ModalActionButton>
        </ModalFooter>
      </Modal>
    );
  }
  return <></>;
};

export default Disable;
